/* eslint-disable object-curly-newline */
/* eslint-disable import/no-cycle */
import React from "react";

import { useNavigate } from "react-router-dom";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

import { useScreenSize } from "../../../component/Theme";

import SompoContext, { SompoContextIF } from "../../../logic/context/SompoContext";

const Status = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { desktop } = useScreenSize();
    const sompoContext = React.useContext<SompoContextIF>(SompoContext);

    // プロフィール画面に遷移
    const handleProfile = () => {
        navigate("/profile");
    };

    return (
        <Box
            sx={{
                width: "100%",
                height: "auto",
                display: "flex",
                alignItems: "center",
                flexFlow: desktop ? "row" : "column",
            }}
        >
            <Box
                sx={{
                    width: desktop ? "50%" : "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "flex-start",
                }}
            >
                <Typography
                    variant="h1"
                    sx={{
                        wordBreak: "break-all",
                    }}
                >
                    {`${sompoContext.userDetail.familyNameJa || ""} ${sompoContext.userDetail.firstNameJa || ""}さんの講座`}
                </Typography>
            </Box>
            <Box
                sx={{
                    width: desktop ? "50%" : "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: desktop ? "center" : "flex-start",
                    flexFlow: desktop ? "row" : "column",
                    borderLeft: desktop ? "2px solid #E9EEF5" : "none",
                }}
            >
                <Box
                    sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexFlow: "column",
                    }}
                >
                    <Button
                        sx={{
                            transition: "all 0.2s ease-in-out",
                            border: `2px solid ${theme.palette.primary.main}`,
                            marginY: "8px",
                        }}
                        onClick={handleProfile}
                    >
                        <Typography variant="h6" sx={{ fontWeight: "bold", color: theme.palette.primary.main }}>
                            マイページ・受講履歴
                        </Typography>
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default Status;
